import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'Copyright',
        dataTn: 'footer-copyright',
        message: (
            <FormattedMessage
                id="dbl.Footer.legal_links_copyright"
                defaultMessage={`© 1stdibs.com, Inc. {year}`}
                values={{ year: new Date().getFullYear() }}
            />
        ),
    },
    {
        trackingLabel: 'User Agreement',
        href: '/about/user-agreement/',
        target: '_blank',
        dataTn: 'footer-agreement',
        message: (
            <FormattedMessage
                id="dbl.Footer.legal_links_agreement"
                defaultMessage="User Agreement"
            />
        ),
    },
    {
        trackingLabel: 'Privacy Policy',
        href: '/about/privacy-policy/',
        target: '_blank',
        dataTn: 'footer-privacy',
        message: (
            <FormattedMessage id="dbl.Footer.legalLinksPrivacy" defaultMessage="Privacy Policy" />
        ),
        badgeText: <FormattedMessage id="dbl.Footer.legalLinksUpdated" defaultMessage="Updated" />,
    },
    {
        trackingLabel: 'Do Not Sell My Info',
        href: 'https://www.1stdibs.com/info/forms2/ccpa-do-not-sell-request/',
        target: '_blank',
        dataTn: 'do-not-sell-main',
        message: (
            <FormattedMessage
                id="dbl.Footer.do_not_sell_main"
                defaultMessage="Do Not Sell My Info"
            />
        ),
    },
    {
        trackingLabel: 'Site Map',
        enablerKey: 'isSiteMapsEnabled',
        href: '/sitemap/',
        classname: 'sitemapMainLink',
        dataTn: 'sitemap-main',
        message: <FormattedMessage id="dbl.Footer.sitemap_links_main" defaultMessage="Site Map" />,
    },
];
